import { render, staticRenderFns } from "./AgentDashboard.vue?vue&type=template&id=0a9dab24&"
import script from "./AgentDashboard.vue?vue&type=script&lang=js&"
export * from "./AgentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9dab24')) {
      api.createRecord('0a9dab24', component.options)
    } else {
      api.reload('0a9dab24', component.options)
    }
    module.hot.accept("./AgentDashboard.vue?vue&type=template&id=0a9dab24&", function () {
      api.rerender('0a9dab24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/AgentDashboard.vue"
export default component.exports